var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor"
      }
    },
    [
      _c("path", {
        attrs: {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          d: "M15.75 19.5L8.25 12l7.5-7.5"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib?{}!./scripts/vue/auth/partials/ChevronLeft.vue?vue&type=template&id=0e567530&
// module id = 186
// module chunks = 0